module.exports = __webpack_public_path__ + "static/media/FoodieFunResized.34a035af.png";